module.exports = __webpack_public_path__ + "img/accepted_dark.9a777d24.svg";